import { useState } from 'react';

export type MarketingConsentFields = {
  'Ignore/MarketingConsent'?: boolean;
  'Ignore/ShowMarketingConsent'?: boolean;
  'Ignore/CoApplicantMarketingConsent'?: boolean;
  'Frontend/CreditStatusConsentRejected'?: boolean;
};

type MarketingConsentDefaultValues = {
  marketingConsent?: boolean;
  showMarketingConsent?: boolean;
  defaultValueOverride?: boolean;
};

export const getMarketingConsentDefaultValues = ({
  marketingConsent,
  showMarketingConsent,
  defaultValueOverride,
}: MarketingConsentDefaultValues) => ({
  'Ignore/MarketingConsent': marketingConsent ?? defaultValueOverride ?? true,
  'Ignore/ShowMarketingConsent': showMarketingConsent ?? true,
});

export const useMarketingConsent = ({
  marketingConsent,
  shouldShowMarketingConsent,
}: {
  marketingConsent?: boolean;
  shouldShowMarketingConsent?: boolean;
}) => {
  const [showMarketingConsent] = useState(
    marketingConsent === true ? false : shouldShowMarketingConsent
  );

  return { showMarketingConsent };
};
